/**
 * Parse free-form pasted shot column (Excel/sheets) into unique tokens.
 * Splits on newlines, tabs, commas, semicolons, and spaces.
 */
export function parseShotFilter(text: string): string[] {
  if (!text || !text.trim()) return [];

  const parts = text
    .split(/[\n\r\t,;\s]+/)
    .map((t) => t.trim())
    .filter(Boolean);

  const seen = new Set<string>();
  const unique: string[] = [];
  for (const p of parts) {
    const key = p.toLowerCase();
    if (!seen.has(key)) {
      seen.add(key);
      unique.push(p);
    }
  }
  return unique;
}
